import SectionHeading from '@/pages/home/components/SectionHeading';
import { people } from '@/mocks/home';

export default function PeopleSection() {
  return (
    <section id="people" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="当事人速览"
          title="当事人与主角速览"
          desc="标题加短摘要的密集列表，先看清每个人在事件里的位置，再决定要不要点进背景档案。"
        />

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {people.map((person, index) => (
            <a
              key={person.name}
              href="#dossiers"
              className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300 md:p-4"
            >
              <span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-md bg-background-200 md:h-16 md:w-16">
                <img src={person.image} alt={`${person.name} 人物封面`} className="h-full w-full object-cover object-top" />
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="font-label text-xs text-foreground-400">{String(index + 1).padStart(2, '0')}</span>
                  <h4 className="font-heading text-base font-semibold text-foreground-950">{person.name}</h4>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">{person.role}</span>
                  <span className="ml-auto hidden items-center gap-1 whitespace-nowrap text-xs text-foreground-500 sm:flex">
                    <i className="ri-fire-line text-accent-500" />
                    {person.heat}
                  </span>
                </div>

                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{person.summary}</p>

                <div className="mt-2 flex flex-wrap items-center gap-1.5">
                  <span className="font-label text-[11px] text-foreground-500">{person.topic}</span>
                  {person.tags.map((tag) => (
                    <span key={tag} className="rounded-md border border-background-200 px-2 py-0.5 font-label text-[11px] text-foreground-600">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}